import React, { useContext, useState, useEffect, useCallback } from "react";
import Box from "@mui/material/Box";
import { APIServices } from "./../../helpers/APIServices";
import { UserContext } from "../../Layout";
import SimpleBackdrop from "../../Components/Backdrop";
import CustomDateHistoryAll2 from "./CustomDateHistoryAll2";

export default function HistoryAll2() {
  const [papers, setPapers] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState(() => sessionStorage.getItem("pending_searchTerm_2") || "");
  const [activeSearch, setActiveSearch] = useState(() => sessionStorage.getItem("pending_activeSearch_2") || "");
  
  // Pagination and Sorting State
  const [page, setPage] = useState(() => parseInt(sessionStorage.getItem("pending_page_2") || "0"));
  const [rowsPerPage, setRowsPerPage] = useState(() => parseInt(sessionStorage.getItem("pending_rowsPerPage_2") || "100"));
  const [order, setOrder] = useState(() => sessionStorage.getItem("pending_order_2") || "desc");
  const [orderBy, setOrderBy] = useState(() => sessionStorage.getItem("pending_orderBy_2") || "create_datetime");
  
  // Date Range State
  const [startDate, setStartDate] = useState(() => sessionStorage.getItem("pending_startDate_2") || "");
  const [endDate, setEndDate] = useState(() => sessionStorage.getItem("pending_endDate_2") || "");

  const user = useContext(UserContext);
  const role = user.qc_role;

  // Initialize status filters based on role or session
  const [statusFilters, setStatusFilters] = useState(() => {
    const saved = sessionStorage.getItem("pending_statusFilters_2");
    if (saved) return JSON.parse(saved);

    if (role === "checker") return ["1"];
    if (role === "approver") return ["2", "4"];
    if (role === "viewer") return ["1", "2", "3", "4", "5"];
    return ["1", "2", "4"]; // defaults for admin
  });

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      if (statusFilters.length === 0) {
          setPapers([]);
          setTotal(0);
          setLoading(false);
          return;
      }

      const response = await APIServices.getAllPaperCheckNull(
          2, 
          page + 1, 
          rowsPerPage, 
          activeSearch, 
          statusFilters,
          order,
          orderBy,
          role,
          startDate,
          endDate
      );

      setPapers(response.data);
      setTotal(response.total);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }, [page, rowsPerPage, activeSearch, statusFilters, order, orderBy, startDate, endDate, role]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Persist state to sessionStorage
  useEffect(() => {
    sessionStorage.setItem("pending_page_2", page.toString());
    sessionStorage.setItem("pending_rowsPerPage_2", rowsPerPage.toString());
    sessionStorage.setItem("pending_order_2", order);
    sessionStorage.setItem("pending_orderBy_2", orderBy);
    sessionStorage.setItem("pending_startDate_2", startDate);
    sessionStorage.setItem("pending_endDate_2", endDate);
    sessionStorage.setItem("pending_statusFilters_2", JSON.stringify(statusFilters));
    sessionStorage.setItem("pending_searchTerm_2", searchTerm);
    sessionStorage.setItem("pending_activeSearch_2", activeSearch);
  }, [page, rowsPerPage, order, orderBy, startDate, endDate, statusFilters, searchTerm, activeSearch]);

  const handleSearch = () => {
    setPage(0);
    setActiveSearch(searchTerm);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleClearSearch = () => {
    setPage(0);
    setSearchTerm("");
    setActiveSearch("");
  };

  const partData = {
    data: papers,
    total: total,
  };

  return (
    <div>
      <SimpleBackdrop open={loading} setOpen={setLoading} />
      <Box sx={{ width: "100%" }}>
        <CustomDateHistoryAll2
          partData={partData}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          onSearch={handleSearch}
          onKeyDown={handleKeyDown}
          onClearSearch={handleClearSearch}
          activeSearch={activeSearch}
          statusFilters={statusFilters}
          setStatusFilters={(newFilters) => {
              setPage(0);
              setStatusFilters(newFilters);
          }}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          order={order}
          setOrder={setOrder}
          orderBy={orderBy}
          setOrderBy={setOrderBy}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
      </Box>
    </div>
  );
}
